export default {
    index(params) {
        return window.axios.get(`/api/cpc-forms`, {
            params,
        });
    },

    get(id) {
        return window.axios.get(`/api/cpc-forms/${id}`);
    },

    store(data) {
        return window.axios.post('/api/cpc-forms', data);
    },

    update(id, data) {
        return window.axios.put(`/api/cpc-forms/${id}`, data);
    },

    delete(id) {
        return window.axios.delete(`/api/cpc-forms/${id}`);
    }
};


// WEBPACK FOOTER //
// ./resources/assets/js/services/CPCFormService.js